import { TRANSMISSION_LABELS } from '@/features/attributes/constants/attributeTranslationKeys'

/**
 * Returns the i18n translation key for a given car transmission type.
 *
 * @param transmissionTypeKey - The numeric key representing the transmission type.
 *   Should correspond to one of the values defined in `TRANSMISSION_VALUES`.
 * @returns The corresponding i18n translation key string.
 *
 * @example
 * getTransmissionTranslation(2);
 * // Returns: 'listing:attributes.car_transmission.automatic'
 */
export const getTransmissionTranslation = (transmissionTypeKey: number) => {
  return TRANSMISSION_LABELS[transmissionTypeKey]
}
